import { useQuery } from "@tanstack/react-query";

import { TenantPermission, getRanaApiV1 } from "@nens/rana/api-v1";

export function useTenantActionAllowed() {
  const tenantPermissionsQuery = useQuery(
    getRanaApiV1().getQueryOptions({
      queryKey: ["permissions"],
      queryFn: async () => getRanaApiV1().TenantsApi.tenantPermissions({}),
    })
  );
  const permissions = (tenantPermissionsQuery.data as Record<TenantPermission, boolean>) ?? {};

  return {
    permissionsLoading: tenantPermissionsQuery.isLoading,
    canReadDatasetList: permissions["dataset_list"] ?? false, // Can read tenant specific data in the catalogue (currently only used for model schematisations)
    canManageDataset: permissions["dataset_manage"] ?? false, // Can write to the catalogue
    canCreateProject: permissions["project_create"] ?? false, // Can create new projects
    canReadAllProjects: permissions["project_list"] ?? false, // Can read all projects including ones you are not a member of. (tenant guests can only read projects they are a member of and for them this is false)
    canCreateNewProject: permissions["project_create"] ?? false, // Can create new projects
    canManageTenant: permissions["tenant_manage"] ?? false, // Can manage the tenant settings (including users and groups)
    canReadUserList: permissions["user_list"] ?? false, // Can read the list of users in the tenant
  };
}
